import { useCallback, useEffect, useState } from "react";

const SECOND = 1000;

export function useCountdown() {
  const [count, setCount] = useState<number>();
  const [id, setId] = useState<number | null>();
  const [isEnded, setIsEnded] = useState<boolean>(false);

  const startCount = useCallback((seconds: number) => {
    if (!id) {
      setCount(() => seconds);
      setIsEnded(false);
      const id = setInterval(() => {
        setCount((c) => (c! > 0 ? c! - 1 : c));
      }, SECOND);
      setId(id as unknown as number);
    }
  }, []);

  useEffect(() => {
    if (count === 0 && id) {
      clearTimeout(id);
      setId(null);
      setIsEnded(true);
    }
  }, [count, id]);

  return { count, startCount, isEnded };
}
